import React, { useCallback, useEffect, useState } from "react";
import { getAboutVision } from "../../api/about";
import DetailSection from "../../components/DetailSection";

const bgImg = "/images/hero-image.jpeg";
const Vision = () => {
  const [pageData, setPageData] = useState(null);

  const getData = useCallback(
    () =>
      getAboutVision()
        .then((res) => setPageData(res))
        .catch((err) => console.log(err)),
    [setPageData]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <>
      <DetailSection
        pageTitle="เกี่ยวกับสำนักงาน"
        headerTitle={pageData?.title ?? "วิสัยทัศน์และพันธกิจ"}
        image={pageData?.topimage?.path}
        alt={pageData?.topimage?.altText}
        content={pageData?.content ?? ""}
      />
    </>
  );
};

export default Vision;
